<template>
  <div v-show="show">
    <div class="text-center mt-10 mb-20">
      <b-button size="lg" variant="success" type="submit" @click="onNextOffer"
        >次のオファー</b-button
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount } from "vue";

import { useOrderStore } from "@/stores/order";
import { useCartStore } from "@/stores/cart";
import { useBaseInfoStore } from "@/stores/base_info";
import { order } from "@/graphql/queries/customers/orders";

interface Props {
  orderNumber: string;
  baseUrl: string;
}

const props = defineProps<Props>();

const orderStore = useOrderStore();
const cartStore = useCartStore();
const baseInfoStore = useBaseInfoStore();

const cvUpsellProducts = computed(() => orderStore.productInfo.cvUpsellProducts);
const cvXsellProducts = computed(() => orderStore.productInfo.cvXsellProducts);

const enableNextOffer = computed(() => orderStore.enableNextOffer);
const offerPosition = computed(() => orderStore.offerPosition);

const show = computed(() => {
  return (cvUpsellProducts.value.length || cvXsellProducts.value.length) && enableNextOffer.value;
});

const onNextOffer = () => {
  orderStore.nextOfferLoading = true;

  orderStore.fetchOffer(props.orderNumber).then(() => {
    orderStore.nextOfferLoading = false;

    const url = new URL(window.location.href);
    url.searchParams.set("offer_position", offerPosition.value.toString());
    window.location.href = url.toString();
  });
};
onBeforeMount(() => {
  cartStore.fetchSelectOptions();
  baseInfoStore.fetchBaseInfo();

  cartStore.lastPage = "thank_offer";
});
</script>
